import { render } from "./CommonConfig.vue?vue&type=template&id=9e595a22&scoped=true"
import script from "./CommonConfig.vue?vue&type=script&lang=js"
export * from "./CommonConfig.vue?vue&type=script&lang=js"

import "./CommonConfig.vue?vue&type=style&index=0&id=9e595a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e595a22"]])

export default __exports__